module.exports = __webpack_public_path__ + "img/light-mud-decal-23.18a45267.png";